import React from 'react';
import { ProgressBar } from '../Components/Controls/ProgressBar';
import LoadingIcon from '../Components/LoadingIcon';
import { useBalance } from '../Context/BalanceProvider';

export const XPLevelSection: React.FC = () => {
  const { xpLevelInfo } = useBalance();

  return (
    <div className="flex flex-col gap-4 h-full">
      <h2 className="text-2xl text-left font-semibold text-neutral-800">
        XP Level
      </h2>

      <div className="flex flex-col justify-center bg-white rounded-lg p-4 gap-4 flex-1 relative">
        {xpLevelInfo ? (
          <>
            <div className="text-blue-600 text-base font-bold absolute top-4 left-4">
              Level {xpLevelInfo.level}
            </div>

            <div className="flex flex-col items-center">
              <img
                src={xpLevelInfo.icon}
                alt="Level Icon"
                className="w-32 h-32 mb-4"
              />
              <div className="text-2xl font-bold">{xpLevelInfo.title}</div>
            </div>

            <div className="flex flex-col w-full">
              <ProgressBar progress={xpLevelInfo.progressInLevel} />
              <div className="flex justify-between items-center text-sm mt-2">
                <div className="text-gray-600">
                  Read for {Math.ceil(xpLevelInfo.xpLeftToNextLevel / 60)} more
                  hours to reach Level {xpLevelInfo.level + 1}
                </div>
                <div className="text-gray-400 whitespace-nowrap">
                  {xpLevelInfo.xpGainedInLevel}/
                  {xpLevelInfo.xpRequiredForNextLevel} XP
                </div>
              </div>
            </div>
          </>
        ) : (
          <LoadingIcon />
        )}
      </div>
    </div>
  );
};
